import { createContext, useContext } from "react";
import { type TimelineLegendFilter } from "constants/filingsTimeline";
import { TimelineFilingRow } from "store/apis/filingsTimeline";

type TimelineContextValue = {
  selectedRowKey: string | null;
  onSelectFiling: (filing: TimelineFilingRow) => void;

  onOpenCart: (entityId: string) => void;

  isIntroAnimated: boolean;

  activeFilter: TimelineLegendFilter | null;
  fadeFilter: TimelineLegendFilter | null;
  onApplyFilter: (filter: TimelineLegendFilter) => void;
  onClearFilter: () => void;
  onPreviewFilter: (filter: TimelineLegendFilter | null) => void;
};

export const TimelineContext = createContext<TimelineContextValue>({
  selectedRowKey: null,
  onSelectFiling: () => {},
  onOpenCart: () => {},
  isIntroAnimated: true,
  activeFilter: null,
  fadeFilter: null,
  onApplyFilter: () => {},
  onClearFilter: () => {},
  onPreviewFilter: () => {},
});

export const useTimelineContext = (): TimelineContextValue =>
  useContext(TimelineContext);
